export const GDPR_REQUEST = "GDPR_REQUEST";
export const GDPR_SUCCESS = "GDPR_SUCCESS ";
export const GDPR_ERROR = "GDPR_ERROR";
